@if (availableDates().length > 0) {
<div class="d-grid col-md-6 col-10 mx-auto ps-4 py-3 rounded-3 fw-medium text-primary">
    <mat-radio-group aria-label="Select a delivery date" formControlName="deliveryDate"
        [value]="availableDates()[0].originalDate" (change)="selectedDate.set($event.value)">
        @for (dates of availableDates(); track $index; let first = $first; let last = $last) {
        <section class="hstack flex-row gap-2">
            <div class="w-75">
                <span class="m-0">
                    {{dates.date}}
                </span>
            </div>
            <div class="w-25 text-end">
                <mat-radio-button [value]="dates.originalDate">
                </mat-radio-button>
            </div>
        </section>
        <hr class="ms-n4">
        }
    </mat-radio-group>
</div>
} @else {
<div class="d-flex flex-column align-items-center justify-content-center col-md-6 col-10 mx-auto py-5 text-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-calendar-x text-muted mb-3" viewBox="0 0 16 16">
        <path d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708"/>
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
    </svg>
    <h5 class="text-muted mb-2">No Available Dates</h5>
    <p class="text-secondary mb-0">There are currently no available delivery dates to display. Please try again later or contact support for assistance.</p>
</div>
}
<div class="row mt-5">
    <div class="col col-md-6 d-grid">
        <button type="button" class="btn btn-outline-primary" (click)="closeModal(false)">Discard changes</button>
    </div>
    <div class="col col-md-6 d-grid">
        <button type="button" class="btn btn-primary" (click)="closeModal(true)" [disabled]="availableDates().length === 0">Confirm</button>
    </div>
</div>